module.exports = __webpack_public_path__ + "img/Delivery-Details.c2e97f7c.jpg";